export const formatTime = (datetime: string | Date): string =>
  new Date(datetime || Date.now()).toLocaleString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
